import Widget, {user, configuration, journey} from '@forgerock/login-widget';
import {useEffect} from 'react';
import {hybrisLogin} from "./HybrisSessionService";

function LoginWidget({contextPath, loginReferer, content, setup}) {

    const config = configuration();
    const journeyEvents = journey();
    const userEvents = user.info();

    useEffect(() => {
        config.set({
            style: {
                checksAndRadios: 'animated',
                labels: 'stacked',
                stage: {
                    icon: false,
                },
            },
            forgerock: {
                clientId: setup.clientId,
                redirectUri: `${window.location.origin}`,
                scope: 'openid profile email',
                serverConfig: {
                    baseUrl: setup.serverBaseUrl,
                    timeout: 5000,
                },
                realmPath: setup.realmPath,
            },
            content: { nextButton: content.signIn, userName: content.username, passwordCallback: content.password },
        });

        const widget = new Widget({
            target: document.getElementById('login-widget-react'),
            props: {
                type: 'inline',
            },
        });

        const userEventsUnsub = userEvents.subscribe((event) => {
                if (event.successful && event.response) {
                    console.log('user event success ', event);
                    const getTokens = user.tokens().get();
                    getTokens.then((token) => {
                        hybrisLogin(token.response.accessToken, contextPath, loginReferer);
                    })
                }
            }
        );

        journeyEvents.start();

        addCustomContent();

        return () => {
            widget.$destroy();
            userEventsUnsub();
        };
    }, []);

    const forgottenPasswordElement = (forgottenPasswordText) => {
        return  `<div class="forgotten-password-container">
                  <div class="row">
                    <a href="${contextPath}/login/pw/reset" class="forgotten-password">
                        ${forgottenPasswordText}
                    </a>
                  </div>
                </div>`;
    };

    const addCustomContent = () => {
        waitForElement("IDToken1-message", setUsernameHintContent, 25);
        waitForElement("IDToken2", setForgottenPasswordContent, 25);
    };

    const setUsernameHintContent = (usernameHintElement) => {
        usernameHintElement.textContent = content.usernameHint;
    }

    const setForgottenPasswordContent = (passwordElement) => {
        passwordElement.parentElement.insertAdjacentHTML(`afterend`, forgottenPasswordElement(content.forgottenPassword));
    }

    const waitForElement = (elementId, callback, retry) => {
        if (retry <= 0) {
            return;
        }
        let element = document.getElementById(elementId)
        if (element) {
            callback(element);
        } else {
            setTimeout(() => {
                waitForElement(elementId, callback, retry - 1);
            }, 200);
        }
    };

    return <div className={`fr-login-widget`} id="login-widget-react"></div>;
}

export default LoginWidget;
